

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
`;

const Label = styled.label`
  font-weight: bold;
  width: 80px;
`;

const Input = styled.input`
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
`;

const Select = styled.select`
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
`;

const SubmitButton = styled.button`
  background-color: #28a745;
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #218838;
  }
`;

const FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;     
  gap: 10px;            
  align-items: center;
`;

const AddUserForm = ({ onAddUser, initialData }) => {
  const [email, setEmail] = useState(initialData?.email || '');
  const [role, setRole] = useState(initialData?.role || 'Viewer');
  const [businessName, setBusinessName] = useState(''); // Add this
  const [selectedBusinessDisplay, setSelectedBusinessDisplay] = useState(''); // Add this
  const [selectedBusinessId, setSelectedBusinessId] = useState("");
  const [account, setAccount] = useState('');
  const [businesses, setBusinesses] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState('');

  useEffect(() => {
    fetchUserAccounts();
  }, []);

  useEffect(() => {
    console.log(selectedAccount)
    if (selectedAccount) {
      fetchLocationsByAccount(selectedAccount);
    } 
  }, [selectedAccount]);

  const handleAccountChange = (accountId) => {
    setSelectedAccount(accountId);
    setBusinessName(''); // Reset business selection
    setSelectedBusinessDisplay(''); // Reset display text
  };

  const fetchUserAccounts = async () => {
    try {
      const userSub = localStorage.getItem('userSub');
      const response = await fetch(`/api/user/68b122f241a6f8b0dda41a11/locations`, {
        method: 'GET',
        credentials: 'include', 
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      
      if (data.success) {
        const accountdetails = data.locations;
        
        // Extract unique accounts
        const uniqueAccounts = [...new Set(accountdetails.map(loc => ({
          accountName: loc.accountName,
          accountId: loc.accountId
        })))];
        setAccounts(uniqueAccounts);
        console.log('Accounts:', uniqueAccounts);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const fetchLocationsByAccount = async (accountId) => {
    try {
      console.log('Fetching locations for account:', accountId);
      
      const response = await fetch(`/api/account/${accountId}/locations`);
      const data = await response.json();
      
      if (data.success) {
        const locations = data.locations;
        
        // Create business objects with display text and IDs
        const uniqueBusinesses = [...new Set(locations.map(loc => ({
          displayText: loc.displayText,
          locationId: loc.locationId,
          placeId: loc.placeId
        })))];
        setBusinesses(uniqueBusinesses);
        
        console.log('Businesses with addresses:', uniqueBusinesses);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const handleBusinessChange = (e) => {
  setSelectedBusinessId(e.target.value); // locationId
  console.log("Selected locationId:", e.target.value);
   // setBusinessName(selectedLocationId); // Store locationId
    
    // Find the business object to get display text
    const selectedBusiness = businesses.find(biz => biz.locationId === e.target.value);
    setSelectedBusinessDisplay(selectedBusiness?.displayText || '');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      alert('Please enter a valid email.');
      return;
    }

    // Find the selected business object
    const selectedBusiness = businesses.find(biz => biz.locationId === selectedBusinessId);

    const newUser = {
      id: initialData?.id || Date.now(),
      email,
      role,
      accountId: account,
      locationId: selectedBusiness?.locationId, // This is already the locationId
      placeId: selectedBusiness?.placeId,
    };
    console.log('new',newUser)
    onAddUser(newUser);
    setEmail('');
    setRole('Viewer');
    setAccount('');
    setBusinessName('');
    setSelectedBusinessDisplay('');
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FlexRow>
        <Label>Email</Label>
        <Input
          type="email"
          placeholder="Enter user email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </FlexRow>

      <FlexRow>
        <Label>Role</Label>
        <Select value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="Admin">Admin</option>
          <option value="Editor">Editor</option>
          <option value="Viewer">Viewer</option>
        </Select>
      </FlexRow>

      <FlexRow>
        <Label>Account Name</Label>
        <Select 
          value={account} 
          onChange={(e) => {
            const selectedAccountId = e.target.value;
            setAccount(selectedAccountId);
            setSelectedAccount(selectedAccountId);
            handleAccountChange(selectedAccountId);
          }}
          required
        >
          <option value="">Select Account</option>
          {accounts.map((acc, index) => (
            <option key={index} value={acc.accountId}>
              {acc.accountName}
            </option>
          ))}
        </Select>
      </FlexRow>

      <FlexRow>
        <Label>Business Name</Label>
        {/* <Select 
          value={businessName} 
          onChange={handleBusinessChange}
          required
          disabled={!selectedAccount}
        >
          <option value="">Select a business</option>
          {businesses.map((business, index) => (
            <option key={index} value={business.locationId}>
              {business.displayText}
            </option>
          ))}
        </Select> */}
        <Select 
  value={selectedBusinessId} 
  onChange={handleBusinessChange}
  required
  disabled={!selectedAccount}
>
  <option value="">Select a business</option>
  {businesses.map((business, index) => (
    <option key={index} value={business.locationId}>
      {business.displayText}
    </option>
  ))}
</Select>

      </FlexRow>

      <SubmitButton type="submit">
        {initialData ? 'Update User' : 'Add User'}
      </SubmitButton>
    </Form>
  );
};

export default AddUserForm;